import { useEffect, useRef } from 'react';

const CTASection = () => {
  const contentRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.querySelectorAll('.cta-reveal').forEach((el, i) => {
              setTimeout(() => {
                (el as HTMLElement).style.opacity = '1';
                (el as HTMLElement).style.transform = 'translateY(0)';
              }, i * 200);
            });
          }
        });
      },
      { threshold: 0.3 }
    );
    if (contentRef.current) observer.observe(contentRef.current);
    return () => observer.disconnect();
  }, []);

  return (
    <section className="relative min-h-[60vh] flex items-center justify-center overflow-hidden">
      {/* Background */}
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=modern%20technology%20expo%20trade%20show%20at%20night%20with%20large%203x2%20meter%20LED%20display%20screens%20on%20exhibition%20stands%2C%20spectacular%20cyan%20blue%20light%20beams%2C%20dramatic%20dark%20atmosphere%2C%20premium%20production%20cinematic%20wide%20angle%2C%20high%20energy%20international%20fair%2C%20large%20format%203x2m%20LED%20displays&width=1920&height=1080&seq=cta003&orientation=landscape"
          alt="Expo espectacular con pantallas LED"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-r from-black/80 via-black/70 to-black/80" />
        <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-transparent to-black/40" />
        <div className="absolute inset-0 bg-[radial-gradient(ellipse_at_center,_rgba(6,182,212,0.08)_0%,_transparent_70%)]" />
      </div>

      <div ref={contentRef} className="relative z-10 max-w-4xl mx-auto px-6 md:px-10 py-24 text-center">
        <div
          className="cta-reveal inline-flex items-center gap-2 border border-cyan-500/40 bg-cyan-500/10 text-cyan-400 text-xs font-semibold uppercase tracking-widest px-4 py-2 rounded-full mb-8"
          style={{ opacity: 0, transform: 'translateY(30px)', transition: 'opacity 0.8s ease, transform 0.8s ease' }}
        >
          <i className="ri-star-fill text-cyan-400" />
          Transforma tu expo hoy
        </div>

        <h2
          className="cta-reveal text-4xl sm:text-5xl md:text-6xl font-extrabold text-white leading-tight mb-6"
          style={{ opacity: 0, transform: 'translateY(30px)', transition: 'opacity 0.8s ease, transform 0.8s ease' }}
        >
          Lleva tu evento al{' '}
          <span className="text-transparent bg-clip-text bg-gradient-to-r from-cyan-400 to-sky-500">
            siguiente nivel
          </span>
        </h2>

        <p
          className="cta-reveal text-gray-300 text-lg md:text-xl font-light max-w-2xl mx-auto mb-10 leading-relaxed"
          style={{ opacity: 0, transform: 'translateY(30px)', transition: 'opacity 0.8s ease, transform 0.8s ease' }}
        >
          Contáctanos ahora y recibe una cotización personalizada en minutos. Nuestro equipo está listo para hacer de tu expo o evento una experiencia visual inolvidable.
        </p>

        <div
          className="cta-reveal flex flex-col sm:flex-row items-center justify-center gap-4"
          style={{ opacity: 0, transform: 'translateY(30px)', transition: 'opacity 0.8s ease, transform 0.8s ease' }}
        >
          <button
            onClick={() =>
              window.open(
                'https://wa.me/5200000000000?text=Hola%2C%20me%20interesa%20cotizar%20pantallas%20para%20mi%20evento',
                '_blank'
              )
            }
            className="flex items-center gap-3 bg-gradient-to-r from-cyan-500 to-sky-600 text-white font-bold text-lg px-10 py-5 rounded-full hover:scale-105 hover:shadow-[0_20px_60px_rgba(6,182,212,0.5)] transition-all duration-300 cursor-pointer whitespace-nowrap"
          >
            <i className="ri-whatsapp-line text-2xl" />
            Cotizar por WhatsApp
          </button>
          <button
            onClick={() => {
              const el = document.querySelector('#services');
              if (el) el.scrollIntoView({ behavior: 'smooth' });
            }}
            className="flex items-center gap-2 border-2 border-white/30 text-white font-medium text-base px-8 py-5 rounded-full hover:border-cyan-400 hover:text-cyan-400 transition-all duration-300 cursor-pointer whitespace-nowrap"
          >
            Ver nuestros servicios
          </button>
        </div>

        {/* Trust indicators */}
        <div
          className="cta-reveal mt-12 flex flex-wrap items-center justify-center gap-6 md:gap-10"
          style={{ opacity: 0, transform: 'translateY(30px)', transition: 'opacity 0.8s ease, transform 0.8s ease' }}
        >
          {[
            { icon: 'ri-shield-check-line', text: 'Garantía de calidad' },
            { icon: 'ri-time-line', text: 'Respuesta en menos de 1 hora' },
            { icon: 'ri-map-pin-line', text: 'Cobertura nacional' },
          ].map((item) => (
            <div key={item.text} className="flex items-center gap-2 text-gray-400 text-sm">
              <i className={`${item.icon} text-cyan-400`} />
              <span>{item.text}</span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default CTASection;
